import { useState, useEffect, useCallback } from "react";
import { useLocation } from "react-router";
import VideoBox from "../../casinoComponents/videoBox";
import BetTableGoals from "../../casinoComponents/betTableGoals";
import GoalBallPopup from "../../casinoComponents/videoBox/overlays/GoalBallPopup";
import ResultGoals from "../resultui/resultGoals/ResultGoals";
import CasinoHeading from "../../casinoComponents/casinoHeading";
import CasinoLastResult from "../../casinoComponents/casinoLastResult";
import MyBet from "../../casinoComponents/myBet";
import CasinoTableLayout from "../../casinoComponents/casinoTableLayout";
import ViewMoreModal from "../../../components/ViewMoreModal";
import { getCasinoGameDetails, getMatchExposure, getCasinoOpenBets } from "../../../apiservices/CasionApi";
import { extractCasinoGame } from "../../../utils/casinoGame";
import "../../../styles/games/goal.css";


export default function Goals() {
  const [gameData, setGameData] = useState(null);
  const [subData, setSubData] = useState([]);
  const [exposures, setExposures] = useState({});
  const [myBets, setMyBets] = useState([]);
  const [showViewMoreModal, setShowViewMoreModal] = useState(false);
  const [gameTitle, setGameTitle] = useState("Goal");
  const [iframeSrc, setIframeSrc] = useState("");

  const { pathname } = useLocation();
  const gameName = extractCasinoGame(pathname) || "goal";
  const isGoal2 = gameName === "goal2";

  useEffect(() => {
    const name = extractCasinoGame(pathname) || "goal";
    setIframeSrc(`https://stream-s-43.uhdmovies.online/casino-stream?id=${name}`);

    const fetchGameData = async () => {
      try {
        const response = await getCasinoGameDetails(name);
        setGameData(response);
        const sub =
          response?.data?.data?.data?.sub ??
          response?.data?.data?.sub ??
          response?.data?.sub ??
          response?.sub ??
          [];
        setSubData(Array.isArray(sub) ? sub : []);
      } catch (err) {
        console.error("Error fetching game data:", err);
      }
    };

    fetchGameData();
    const gameDataInterval = setInterval(fetchGameData, 1500);
    return () => clearInterval(gameDataInterval);
  }, [pathname]);

  const fetchExposure = useCallback(async () => {
    try {
      const user = JSON.parse(localStorage.getItem("user") || "{}");
      const userId = user?.user_id || user?.id || user?.staff_id || user?.owner_id;
      const matchId =
        gameData?.data?.data?.mid?.toString() ||
        gameData?.data?.mid?.toString() ||
        gameData?.mid?.toString();

      if (userId && matchId) {
        const response = await getMatchExposure(userId, matchId);
        if (response.success && response.data) {
          const exposureMap = {};
          response.data.forEach((item) => {
            const key = item.team_name || item.selection || item.player_name || "";
            if (!key) return;
            const amount = parseFloat(item.exposure_amount) || 0;
            // "No Goal" is a runner of BOTH booked markets (game_type
            // "goal:player" / "goal:method") — keep a per-market key too, the
            // plain name alone would let one market overwrite the other.
            if (item.game_type) exposureMap[`${item.game_type}|${key}`] = amount;
            exposureMap[key] = amount;
          });
          setExposures(exposureMap);
        }
      }
    } catch (error) {
      console.error("Error fetching exposure:", error);
    }
  }, [
    gameData?.data?.data?.mid,
    gameData?.data?.mid,
    gameData?.mid,
  ]);

  const fetchMyBetsData = useCallback(async () => {
    if (!gameName) return;
    try {
      const response = await getCasinoOpenBets(gameName);
      if (response?.success && Array.isArray(response.data)) {
        const formattedBets = response.data.map((bet) => ({
          // My Bets "Gametype" column (casino_bets.game_name, e.g. mogambo)
          description: bet.description ?? bet.game_name ?? bet.gameName,
          userName: bet.username || bet.userName || "-",
          matchedBet: bet.matchedBet || bet.nation || bet.selection || bet.player_name || "-",
          selection: bet.selection || bet.player_name || bet.matchedBet || "",
          player_name: bet.player_name || "",
          odds: bet.odds ?? bet.userrate ?? "0",
          stake: bet.stake ?? bet.amount ?? "0",
          placeDate: bet.placeDate ?? bet.created_at ?? "-",
          gametype: bet.gametype ?? bet.game_type ?? (bet.type === "lay" ? "Lay" : bet.type === "back" ? "Back" : "-"),
          type: bet.type || null,
          exposer: parseFloat(bet.exposer || bet.exposure_amount || "0") || 0,
        }));
        setMyBets(formattedBets);
      }
    } catch (error) {
      console.error("Error fetching my bets:", error);
    }
  }, [gameName]);

  useEffect(() => {
    const matchId =
      gameData?.data?.data?.mid?.toString() ||
      gameData?.data?.mid?.toString() ||
      gameData?.mid?.toString();

    if (matchId) {
      const t = setTimeout(() => fetchExposure(), 2000);
      const exposureInterval = setInterval(fetchExposure, 2000);
      return () => {
        clearTimeout(t);
        clearInterval(exposureInterval);
      };
    }
  }, [fetchExposure, gameData]);

  useEffect(() => {
    fetchMyBetsData();
    const intervalId = setInterval(fetchMyBetsData, 3000);
    return () => clearInterval(intervalId);
  }, [fetchMyBetsData]);

  const handleBetClick = () => {
    fetchExposure();
    fetchMyBetsData();
  };

  const roundId =
    gameData?.data?.data?.mid ||
    gameData?.data?.mid ||
    gameData?.mid ||
    "";
  const remark = gameData?.data?.data?.remark ?? gameData?.data?.remark ?? "";
  const rdesc = gameData?.data?.data?.rdesc ?? gameData?.data?.rdesc ?? "";

  // Reference markup: .casino-table.five-cricket.super-over.detail-page-container.ball-by-ball.goal >
  // .game-header, .casino-video.mt-0 (soccer-ball popup while rdesc is set), .market-container,
  // .casino-remark, Last Result (no .casino-detail wrapper). Title = lastresults res1.cname ("Goal").
  return (
    <CasinoTableLayout
      tableClass={`five-cricket super-over detail-page-container ball-by-ball goal${isGoal2 ? " goal2" : ""}`}
      rightSide={<MyBet bets={myBets} onViewMore={() => setShowViewMoreModal(true)} />}
    >
      <CasinoHeading name={gameTitle} roundId={roundId} />{" "}
      <VideoBox
        className="mt-0"
        iframeSrc={iframeSrc}
        timerValue={gameData?.data?.data?.lt}
        gameType="goal"
        cardsOverlay={<GoalBallPopup rdesc={rdesc} />}
      />{" "}
      {roundId ? (
        <BetTableGoals goal2={isGoal2} onBetClick={handleBetClick} data={subData} exposures={exposures} myBets={myBets} />
      ) : null}{" "}
      {remark !== "" && (
        <div className="casino-remark mt-3">
          <div className="remark-icon">
            <img src={`${import.meta.env.BASE_URL}assets/img/icons/remark.png`} alt="" />
          </div>{" "}
          <marquee>{remark}</marquee>
        </div>
      )}{" "}
      <CasinoLastResult
        gameType={gameName}
        resultComponent={<ResultGoals gameType={gameName} roundId={roundId || undefined} onTitle={setGameTitle} />}
      />
      <ViewMoreModal
        show={showViewMoreModal}
        onHide={() => setShowViewMoreModal(false)}
        title="View More"
        sectionKey={gameName}
      />
    </CasinoTableLayout>
  );
}
